
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 3H1.068C.477 3 0 3.497 0 4.111v7.778C0 12.503.478 13 1.067 13h13.866c.59 0 1.067-.498 1.067-1.111V6.125c-.168.079-.347.137-.533.172v5.592a.545.545 0 01-.534.555H1.067a.545.545 0 01-.534-.555V4.11c0-.307.24-.555.534-.555h11.768c.033-.195.09-.381.165-.556z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M13.983 4.188a.614.614 0 01-.305-.077.58.58 0 01-.301-.515.58.58 0 01.301-.515.595.595 0 01.305-.081c.11 0 .212.027.305.081a.559.559 0 01.222.217c.055.09.082.19.082.298a.588.588 0 01-.305.515.614.614 0 01-.304.077zm1.182-1.14h.328l-1.282 2.264h-.327l1.281-2.263zm-1.182.9a.34.34 0 00.252-.1.33.33 0 00.102-.246c0-.099-.034-.182-.102-.249a.34.34 0 00-.252-.1.34.34 0 00-.354.35c0 .096.033.178.099.245a.35.35 0 00.255.1zm1.407 1.413a.614.614 0 01-.304-.078.58.58 0 01-.301-.515.58.58 0 01.3-.515.595.595 0 01.305-.08c.11 0 .212.026.305.08a.558.558 0 01.222.217c.055.09.083.19.083.298a.588.588 0 01-.305.515.614.614 0 01-.305.078zm-.003-.24a.35.35 0 00.255-.1.33.33 0 00.103-.246.35.35 0 00-.358-.35.346.346 0 00-.354.35c0 .097.034.179.103.246.068.067.152.1.251.1zM4.104 6.886h.566l.865 2.22.868-2.22h.563L5.795 9.82h-.516L4.104 6.886zM7.91 6.886h.516l1.17 2.934h-.54l-.27-.676H7.546l-.265.676h-.545L7.91 6.886zm.73 1.817l-.474-1.246-.474 1.246h.948zM10.208 7.327h-.885v-.44h2.304v.44h-.886V9.82h-.533V7.327z","fill":"#6C6C6C"}}),_c('path',{attrs:{"fill":"#fff","d":"M5 12h1v1H5zM13 12h2v1h-2zM5 3h1v1H5z"}})])
          )
        }
      }
    